import occasions from "./Occasions"

export default occasions
